import { useQuery } from "@tanstack/react-query";
import { AccountReceivableControllerApi } from "../../services";
import { getConfigObject, useBaseData } from "../../utils/utils";
import { PatientAccountReceivableRow } from "../../pages/app/provider/billings/account-receivable/patient/AccountReceivablePatientTable";

interface useAccountReceivableTotalProps {
  searchString?: string | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
  xTENANTID?: string | undefined;
  payerType:string;
}
export const useAccountReceivableTotal = ({
  searchString,
  startDate,
  endDate,
  xTENANTID,
  payerType
}: useAccountReceivableTotalProps): useBaseData<PatientAccountReceivableRow> => {
  return useQuery({
    queryKey: [
      "patient-account-receivable-totals",
      searchString,
      startDate,
      endDate,
      xTENANTID,
      payerType,
    ],
    queryFn: async () =>
      new AccountReceivableControllerApi(
        getConfigObject()
      ).getPatientAccountReceivableTotals(
        searchString,
        startDate,
        endDate,
        payerType,
        xTENANTID
      ).then((res) => res?.data),
  });
};
